import { changeToCamelCase } from '@interlayer/js/app/utils/common.util';

export const parseStyleAttributes = (data?: Record<string, unknown>) => {
    if (typeof data?.style !== 'string') {
        return data;
    }

    const style = data.style.split(';').reduce((acc, current) => {
        const [key = '', value = ''] = current.split(':');

        if (value && key) {
            acc[changeToCamelCase(key.trim())] = value.trim();
        }

        return acc;
    }, {} as Record<string, string>);

    return {
        ...data,
        style
    };
};
